// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vis-cf-background-opacity-separator{color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);opacity:0.2;margin-top:16px !important}.vis-cf-panelContainer.is-disabled{cursor:not-allowed;opacity:0.4}.vis-cf-panelContainer-inner.is-disabled{pointer-events:none}\n", ""]);
// Exports
module.exports = exports;
